const InstructorCard = ({ name, title, image, email }) => {
	return (
		<div className='bg-blue-50  rounded-xl shadow-md p-4 border border-blue-200 hover:shadow-xl shadow-blue-200 transition-transform duration-300'>
			<img
				src={image}
				alt={name}
				className='w-full h-64 object-cover rounded-lg mb-4'
			/>
			<h3 className='text-blue-500 text-lg font-bold'>{name}</h3>
			<p className='text-gray-800 text-sm'>{title}</p>
			<p className='text-gray-800 text-sm'>{email}</p>
		</div>
	);
};

export default InstructorCard;
